<template>
  <flipper :status="maquina.status" :active="field === 'oee'" class="layout-container">
    <div class="row">
      <Frame title="Máquina">
        <button
          v-if="fake"
          style="position:absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: transparent; border: none"
          @click="fakeStatusChange"
        ></button>
        <rlabel class="info-frame" v-if="!maquina.descricao" :text="maquina.codigo">
          <i class="material-icons md-info">settings</i>
        </rlabel>
        <rlabel
          class="info-frame"
          v-else
          :text="machineLabel === 1 ? maquina.codigo : machineLabel === 2 ? maquina.descricao : maquina.codigo + '-' + maquina.descricao"
        >
          <i class="material-icons md-info">settings</i>
        </rlabel>
      </Frame>
      <Frame title="Ordem" v-if="maquina.ordem">
        <rlabel class="info-frame" :text="maquina.ordem">
          <i class="material-icons md-info">assignment_late</i>
        </rlabel>
      </Frame>
      <Frame title="Peça" v-if="maquina.peca">
        <rlabel class="info-frame" :text="maquina.peca">
          <i class="material-icons md-info">build</i>
        </rlabel>
      </Frame>
    </div>
    <main :class="['main-row', field === 'qualidade' && 'qualidade-row']">
      <div :class="['grid-wrapper', field === 'qualidade' && 'qualidade-wrapper']">
        <div class="grid-container clearfix">
          <p class="grid-title" v-if="field === 'oee'">OEE</p>
          <p class="grid-title" v-else-if="field === 'disponibilidade'">Disponibilidade</p>
          <p class="grid-title" v-else-if="field === 'qualidade'">Qualidade</p>
          <div class="grid-main-chart">
            <chart-container>
              <Doughnut v-if="field === 'oee'" color="#006064" v-bind:complete="maquina.oee" />
              <Doughnut
                v-else-if="field === 'disponibilidade'"
                color="rgba(54, 162, 235, 0.6)"
                v-bind:complete="maquina.disponibilidade"
              />
              <Doughnut
                v-else-if="field === 'qualidade'"
                color="#90A4AE"
                v-bind:complete="maquina.qualidade"
              />
            </chart-container>
          </div>
          <div class="line-container">
            <chart-container>
              <line-chart
                v-if="field === 'oee'"
                color="#006064"
                label="OEE"
                v-bind:history="historicoLinhaOEE"
              ></line-chart>
              <line-chart
                v-else-if="field === 'disponibilidade'"
                color="#36A2EB"
                label="Disponibilidade"
                v-bind:history="historicoLinhaDisponibilidade"
              ></line-chart>
              <line-chart
                v-else-if="field === 'qualidade'"
                color="#90A4AE"
                label="Disponibilidade"
                v-bind:history="historicoLinhaQualidade"
              ></line-chart>
            </chart-container>
          </div>
          <div v-if="field === 'oee'" class="grid-trio">
            <Frame title="Desempenho">
              <frame-content>
                <chart-container>
                  <Doughnut color="#F57F17" v-bind:complete="maquina.desempenho" />
                </chart-container>
              </frame-content>
            </Frame>
            <Frame title="Disponibilidade">
              <frame-content>
                <chart-container>
                  <Doughnut
                    color="rgba(54, 162, 235, 0.6)"
                    v-bind:complete="maquina.disponibilidade"
                  />
                </chart-container>
              </frame-content>
            </Frame>
            <Frame title="Qualidade">
              <frame-content>
                <chart-container>
                  <Doughnut color="#90A4AE" v-bind:complete="maquina.qualidade" />
                </chart-container>
              </frame-content>
            </Frame>
          </div>
          <div
            v-else-if="field !== 'oee'"
            :class="['grid-trio', field=== 'qualidade' && 'qualidade-grid']"
          >
            <Frame title="Principais Paradas" v-if="field === 'disponibilidade'">
              <chart-container>
                <bar-chart
                  color="#E05959"
                  label="Disponibilidade"
                  v-bind:valores="principaisParadas"
                  suffix="h"
                ></bar-chart>
              </chart-container>
            </Frame>
            <Frame title="Principais Defeitos" v-if="field === 'qualidade'">
              <chart-container>
                <bar-chart color="#2Aa987" label="Qualidade" v-bind:valores="principaisDefeitos"></bar-chart>
              </chart-container>
            </Frame>
          </div>
        </div>
      </div>
      <div
        v-if="field === 'qualidade'"
        style="display: flex; border-radius: 1rem; margin-top: 0.6rem; width: 33%; height: calc(30% - 0.6rem)"
      >
        <Frame title="Boas" background="#4ac200" style="margin-right: 0.3rem;">
          <p class="frame-qualidade">3000</p>
        </Frame>
        <Frame title="Defeituosas" background="#ffa200" style="margin-left: 0.3rem">
          <p class="frame-qualidade">30</p>
        </Frame>
      </div>
    </main>
    <div class="status-row" v-if="field !== 'qualidade'">
      <Frame title="Status" v-if="field === 'oee'">
        <status-prod
          :status="maquina.status"
          :atraso="maquina.atraso"
          :motivo="maquina.motivoParada"
          :progress="maquina.progress"
          :total="maquina.total"
          :tempoEstado="maquina.tempoEstado"
          :extra="'00:15:00'"
        ></status-prod>
      </Frame>
      <Frame title="Histórico de Status Máquina" v-else-if="field === 'disponibilidade'">
        <frame-content style="display: flex">
          <chart-legend></chart-legend>
          <chart-container>
            <timeline-chart label="Disponibilidade" v-bind:valores="historicoStatus"></timeline-chart>
          </chart-container>
        </frame-content>
      </Frame>
    </div>
  </flipper>
</template>

<script>
import Frame from "../components/Frame.vue";
import Doughnut from "../components/charts/Doughnut.js";
import Line from "../components/charts/Line.js";
import Bar from "../components/charts/Bar.js";
import Timeline from "../components/charts/Timeline.js";
import ChartContainer from "../components/ChartContainer.vue";
import FrameContent from "../components/FrameContent.vue";
import StatusProd from "../components/StatusProd.vue";

import ResponsiveLabel from "../components/ResponsiveLabel.vue";
import Legend from "../components/Legend.vue";
import Flipper from "../components/FlippingCard.vue";

import fakeData from "../store/fakeData.js";

export default {
  name: "major",
  components: {
    Frame: Frame,
    Doughnut: Doughnut,
    "chart-container": ChartContainer,
    "frame-content": FrameContent,
    "status-prod": StatusProd,
    "line-chart": Line,
    "bar-chart": Bar,
    "timeline-chart": Timeline,
    rlabel: ResponsiveLabel,
    "chart-legend": Legend,
    flipper: Flipper
  },
  props: {
    maquina: Object,
    field: String
  },
  methods: {
    fakeStatusChange() {
      if (this.maquina.status === "Produção")
        fakeData[this.maquina.indice - 1].status = "Parada";
      else if (this.maquina.status === "Parada")
        fakeData[this.maquina.indice - 1].status = "Ocioso";
      else if (this.maquina.status === "Ocioso")
        fakeData[this.maquina.indice - 1].status = "Setup";
      else if (this.maquina.status === "Setup")
        fakeData[this.maquina.indice - 1].status = "Produção";
    }
  },
  computed: {
    machineLabel() {
      return this.$store.state.machineLabel;
    },
    fake() {
      return this.$store.state.fake;
    },
    pieceLabel() {
      return this.$store.state.pieceLabel;
    },
    historicoLinhaOEE() {
      return {
        valores: this.maquina.historicoOEE,
        datas: this.maquina.dataHistoricoOEE
      };
    },
    historicoLinhaDisponibilidade() {
      return {
        valores: [2.0, 4.1, 30, 40, 23, 0, 20],
        datas: ["10/04", "11/04", "12/04", "13/04", "14/04", "15/04"]
      };
    },
    historicoLinhaQualidade() {
      return {
        valores: [2.0, 4.1, 30, 100, 23, 0, 20],
        datas: ["10/04", "11/04", "12/04", "13/04", "14/04", "15/04"]
      };
    },
    principaisParadas() {
      return {
        labels: [
          "Injustificada",
          "Manutenção Corretiva",
          "Troca de Ferramenta",
          "Liberada de Manutenção",
          "Manutentor na Máquina"
        ],
        valores: [358.33, 140.12, 140, 140, 3.4]
      };
    },
    principaisDefeitos() {
      return {
        labels: [
          "Quebrada",
          "Corte Incorreto",
          "Porosidade",
          "Deformidade",
          "Outros Defeitos"
        ],
        valores: [135, 72, 66, 40, 10]
      };
    },
    historicoStatus() {
      const today = this.moment();
      const yesterday = today.clone().add(-1, "day");
      const formatConfig = "YYYY-MM-DD[T]HH:mm:ss";
      return [
        {
          gap: [
            yesterday
              .hour(18)
              .minute(0)
              .second(0)
              .format(formatConfig),
            yesterday
              .hour(22)
              .minute(0)
              .second(0)
              .format(formatConfig)
          ],
          status: "Parada"
        },
        {
          gap: [
            yesterday
              .hour(22)
              .minute(0)
              .second(0)
              .format(formatConfig),
            today
              .hour(3)
              .minute(0)
              .second(0)
              .format(formatConfig)
          ],
          status: "Produção"
        },
        {
          gap: [
            today
              .hour(3)
              .minute(0)
              .second(0)
              .format(formatConfig),
            today
              .hour(3)
              .minute(16)
              .second(0)
              .format(formatConfig)
          ],
          status: "Ocioso"
        },
        {
          gap: [
            today
              .hour(3)
              .minute(16)
              .second(0)
              .format(formatConfig),
            today
              .hour(4)
              .minute(0)
              .second(0)
              .format(formatConfig)
          ],
          status: "Em Setup"
        },
        {
          gap: [
            today
              .hour(4)
              .minute(0)
              .second(0)
              .format(formatConfig),
            today
              .hour(15)
              .minute(20)
              .second(0)
              .format(formatConfig)
          ],
          status: "Produção"
        },
        {
          gap: [
            today
              .hour(15)
              .minute(20)
              .second(0)
              .format(formatConfig),
            today
              .hour(16)
              .minute(0)
              .second(0)
              .format(formatConfig)
          ],
          status: "Ocioso"
        },
        {
          gap: [
            today
              .hour(16)
              .minute(0)
              .second(0)
              .format(formatConfig),
            today
              .hour(23)
              .minute(0)
              .second(0)
              .format(formatConfig)
          ],
          status: "Produção"
        }
      ];
    }
  }
};
</script>

<style scoped>
.row {
  display: flex;
  height: 10rem;
  border-radius: 1rem;
  margin-bottom: 0.8rem;
}
.row > :not(:last-child) {
  margin-right: 0.8rem;
}

.info-frame {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 calc(1rem + 1em);
}

.main-row {
  height: 50%;
  border-radius: 1rem;
  margin-bottom: 0.8rem;
}

.qualidade-row {
  height: calc(100% - 18rem);
}

.grid-wrapper {
  height: 100%;
  background: transparent;
  position: relative;
}

.qualidade-grid {
  position: absolute;
  right: 0;
  top: 50%;
  height: calc(100% - 3.6rem) !important;
}

.qualidade-wrapper {
  height: 70%;
}

.grid-container {
  height: 100%;
  border-top: 2.5rem solid #37474f;
  border-top: 2.5rem solid var(--color-tertiary);
  border-radius: 1rem 1rem 0 0;
}

.grid-title {
  position: absolute;
  top: 0;
  left: 1.2rem;
  font-size: 2rem;
  font-weight: bold;
}

.grid-main-chart {
  width: 33%;
  background: #263238;
  background: var(--color-secondary);
  float: left;
  height: 100%;
  margin-right: 0.8rem;
  border-radius: 0px 0px 1rem 1rem;
  padding: 3rem;
}

.line-container {
  width: calc(67% - 0.8rem);
  background: #263238;
  background: var(--color-secondary);
  height: 45%;
  display: inline-block;
  position: relative;
  border-radius: 0px 0px 1rem 0px;
}

.line-container::before {
  position: absolute;
  height: 100%;
  background: #263238;
  background: var(--color-secondary);
  content: "";
  display: block;
  width: 1.2rem;
  left: -1.2rem;
}

.grid-trio {
  display: flex;
  border-radius: 1rem;
  height: calc(100% - 45% - 0.8rem);
  width: calc(67% - 0.8rem);
  margin-top: 0.6rem;
}

.grid-trio > *:not(:last-child) {
  margin-right: 0.8rem;
}

.status-row {
  height: calc(50% - 10rem - 7rem - 1.6rem);
  height: calc(50% - 10rem - var(--header-height) - 1.6rem);
  border-radius: 1rem;
  font-size: 6rem;
}

.layout-container {
  height: 100%;
}

.material-icons.md-info {
  font-size: 1em;
  justify-self: flex-start;
  position: absolute;
  left: 1rem;
}

.frame-qualidade {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  font-size: 4vw;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }
  .main-row {
    height: 50vh;
    max-height: 50vh;
  }
  .grid-container {
    height: 50vh;
    max-height: 50vh;
  }
  .grid-wrapper {
    height: 50vh;
    max-height: 50vh;
  }
  .status-row {
    margin-top: 0.8rem;
    height: calc(100vh - 50vh - 10rem - 7rem - 3.2rem);
  }
  .grid-trio > * {
    width: calc(100% / 3 - 0.5rem);
  }
}
</style>
